import { useLocalStorage } from '../core/hooks/useLocalStorage'

type CurrentUser = {
  userId: string
  username: string
}

/**
 * Verify if the provided file URL has the full Object key path and return the correct path
 * @example Incorrect path: `Profile/picture_2024-10-09.jpg`
 * Correct path: `private/c45fb22b-ba6d-4c99-9c18-12714ddb601c/Profile/picture_2024-10-09.jpg`
 * @param fileUrl
 * @returns Image path following the pattern `private/[user-sub-id]/[file-path]`
 */
export const useGetFileUrl = (fileUrl?: string) => {
  const [currentUser] = useLocalStorage<CurrentUser | null>('currentUser', null)

  if (!fileUrl) {
    return ''
  }

  if (fileUrl.startsWith('private')) {
    return fileUrl
  }

  if (!currentUser) {
    return ''
  }

  return `private/${currentUser?.userId}/${fileUrl}`
}
